import React from 'react';
import { Toast, ToastContainer, Button } from 'react-bootstrap';

/** A Toast showing PWA update notification with 2 options: Reload or Later */
const PwaUpdateToast = ({ show, onDismiss, onReload }) => {
    return (
        <ToastContainer className="p-3" position="top-end">
            <Toast show={show} onClose={onDismiss}>
                <Toast.Header>
                    <strong className="me-auto">Update Available</strong>
                </Toast.Header>
                <Toast.Body>
                    <p>Update available. Internet stable? Reload now?</p>
                    <p className="text-muted small">
                        (Kalo lagi bayar ato di underground pilio 'Later')
                    </p>
                    <div className="d-flex justify-content-end gap-2 mt-3">
                        <Button variant="secondary" size="sm" onClick={onDismiss}>
                            Later
                        </Button>
                        <Button variant="primary" size="sm" onClick={onReload}>
                            Reload
                        </Button>
                    </div>
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

export default PwaUpdateToast;
